import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type AgendaTemplateFragment = { createdById: string, createdAt: string, updatedAt: string, id: string, versionNumber?: number | null, name: string, agendaItemIds: Array<string>, status: Types.AgendaItemTemplateStatusEnum, meetingsCount: number };


export type AgendaTemplateFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const AgendaTemplateFragmentDoc = /*#__PURE__*/ gql`
    fragment AgendaTemplate on AgendaItemTemplateType {
  createdById
  createdAt
  updatedAt
  id
  versionNumber
  name
  agendaItemIds
  status
  meetingsCount
}
    `;